import s from './empty-state.module.scss'

export const EmptyState = ({ text }) => (
    <div className={s.emptyState}>
        <img
            className={s.emptyImg}
            src={process.env.REACT_APP_STORAGE_URL + 'images/mascot/man-looking.webp'}
            alt='Человечек с лупой'
        />
        <div className={s.emptyText}>{text}</div>
    </div>
)
